import { render, staticRenderFns } from "./ModuleAdditionalConfigForm.vue?vue&type=template&id=2afb8914&scoped=true"
import script from "./ModuleAdditionalConfigForm.vue?vue&type=script&lang=js"
export * from "./ModuleAdditionalConfigForm.vue?vue&type=script&lang=js"
import style0 from "./ModuleAdditionalConfigForm.vue?vue&type=style&index=0&id=2afb8914&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb8914",
  null
  
)

export default component.exports